import { defineStore } from "pinia";

export const useProductStore = defineStore("productStore", {
  state: () => ({
    product: null,
  }),

  getters: {
    id(state) {
      return Number(state.product?.id);
    },

    totalRatings(state) {
      return state.product?.rating.total;
    },

    averageRating(state) {
      return state.product?.rating.average || 0;
    },

    ratingCounts(state) {
      return (
        state.product?.rating.counts.map((item) => {
          const percentage =
            this.totalRatings > 0 ? (100 * item.count) / this.totalRatings : 0;
          return {
            ...item,
            percentage,
          };
        }) || []
      );
    },
    ratingStars(state) {
      return new Array(this.ratingCounts.length).fill().map((_, index) => {
        const pos = index + 1;
        if (Math.floor(this.averageRating) >= pos) {
          return "full";
        } else if (Math.ceil(this.averageRating) === pos) {
          if (this.averageRating % 1 > 0.5) {
            return "full";
          } else {
            return "half";
          }
        }
        return "empty";
      });
    },
  },
  actions: {
    set(data) {
      this.product = data;
    },
  },
});
